export const SALES_DETAILS_PAYMENTS = 10;
